import styled, { css } from 'styled-components';
import { Button } from 'reactstrap';


const SuggestionsAndLinksButtonAndLinkCommonStyle = css`
    padding: 1rem;
    outline: none;
    font-size: 16px;
    color: #ffffff;
    background-color: rgba(var(--primeiro), 1);
    width: 100%;
    border-radius: 16px;
    box-shadow: 15px 10px 20px -13px rgba(var(--primeiro), 1), -20px -10px 20px -10px rgba(var(--preto), 0.1), inset 3px 3px 10px 5px rgba(255, 255, 255, 0.5);
`

export const SuggestionsAndLinksButton = styled(Button)`
    ${SuggestionsAndLinksButtonAndLinkCommonStyle}
`
export const SuggestionsAndLinksLink = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-decoration: none;
    &:hover{
        background-color: #6c757d;
        color: #fff;
    }
    ${SuggestionsAndLinksButtonAndLinkCommonStyle}
`
